const defaults = {
    transitionDuration: '300ms',
    touchThresholdMultiplier: 0.25, // percent(25)/100 = .25
    minLargeScreenBreakPoint: 769
};

function getSupportedPassiveCaptureOption(){
    var passiveIfSupported = false;

    try {
    window.addEventListener("test", null, Object.defineProperty(
        {},
        "passive",
        {
            // eslint-disable-next-line getter-return
            get: function() {
                passiveIfSupported = { passive: true }; 
            }
        }
        )
    );
        // eslint-disable-next-line no-empty, no-unused-vars
    } catch(err) {}

    return passiveIfSupported;
}

function PanelSlider(element, options) {
    if (!element || !element.children.length || !/ol|ul/gi.test(element.nodeName)) {
        throw new Error('PanelSlider requires an list element that contains child elements');
    }

    var passiveIfSupported = getSupportedPassiveCaptureOption();

    this.options = extend({}, defaults, options || {});
    this.$carousel = element;
    this.isLargeScreen = window.matchMedia(
        'screen and (min-width: ' + this.options.minLargeScreenBreakPoint + 'px)'
    ).matches;
    this.$wrapper = document.createElement('div');
    this.$wrapper.classList.add('ps');
    this.$carousel.parentElement.insertBefore(this.$wrapper, this.$carousel);
    this.$container = document.createElement('div');
    this.$container.setAttribute('role', 'region');
    this.$container.setAttribute('aria-label', 'Slideshow');
    this.$container.classList.add('ps-overflow');
    this.$wrapper.appendChild(this.$container);
    this.$carousel.classList.add('ps-content');
    this.$controls = document.createElement('div');

    if (this.isLargeScreen) {
        addNavigation(this);
    }

    this.setDimensionsAndPosition();
    this.$container.appendChild(this.$carousel);
    this.$wrapper.addEventListener('click', this.handleClick.bind(this), true);

    lazyLoadImagesOnFirstInteraction(this.$carousel, this.loadImage.bind(this));

    this.isTouching = false;
    this.touchThreshold = this.containerWidth * this.options.touchThresholdMultiplier;

    this.$carousel.addEventListener('dragstart', function(e) {
        e.preventDefault();
    });

    if (!this.isLargeScreen && this.pageCount > 1) {
        addProgessIndicator(this);
        this.setActiveProgresIndicator(0);
    }

    if (this.pageCount > 1) {
        if (this.isLargeScreen) {
            this.showArrows(0);
        }
        this.$carousel.addEventListener('touchstart', this.touchStart.bind(this), passiveIfSupported);
        this.$carousel.addEventListener('touchmove', this.touchMove.bind(this), passiveIfSupported);
        this.$carousel.addEventListener('touchend', this.touchEnd.bind(this));
        this.$carousel.addEventListener('mousedown', this.touchStart.bind(this));
        this.$carousel.addEventListener('mousemove', this.touchMove.bind(this));
        this.$carousel.addEventListener('mouseup', this.touchEnd.bind(this));
        this.$carousel.addEventListener('mouseleave', this.touchEnd.bind(this));
    }
}

PanelSlider.prototype.refresh = function() {
    this.loaded = false;
    this.setDimensionsAndPosition();
    this.loadImage();

    if (!this.isLargeScreen) {
        return;
    }

    if (this.pageCount > 1) {
        this.showArrows(0);
    } else {
        this.$prev.style.display = 'none';
        this.$next.style.display = 'none';
    }
};

PanelSlider.prototype.setDimensionsAndPosition = function() {
    this.$$items = [].slice.call(this.$carousel.children);

    this.$$items.forEach(function(element) {
        element.classList.add('ps-item');
    });

    this.containerWidth = this.$container.clientWidth;
    this.itemWidth = this.$$items[0].clientWidth;
    this.itemsPerPage = calcItemsPerPage(this.itemWidth, this.containerWidth);

    this.$$items.forEach(
        function($item) {
            $item.style.width = this.itemWidth + 'px';
        }.bind(this)
    );

    adjustItemToFitEvenlyWithInContainer(this);

    this.pageCount = Math.ceil(this.$$items.length / this.itemsPerPage);
    this.sliderWidth = this.pageCount * this.containerWidth;
    this.negativePositionLimit = -(this.sliderWidth - this.containerWidth);
    this.currentPosition = 0;
    this.$carousel.style.minWidth = this.sliderWidth + 'px';
    this.$carousel.style.transitionDuration = this.options.transitionDuration;
    this.setPosition(this.currentPosition);
};

PanelSlider.prototype.getPageIndexFromPosition = function(position) {
    return Math.abs(position / this.containerWidth);
};

PanelSlider.prototype.setActiveProgresIndicator = function(index) {
    var $active = this.$progress.querySelector('.ps-indicator-active');

    if ($active) {
        $active.classList.remove('ps-indicator-active');
    }

    this.$progress.children[index].classList.add('ps-indicator-active');
};

PanelSlider.prototype.touchStart = function(e) {
    this.isTouching = true;
    this.start = e.touches ? e.touches[0].pageX : e.pageX;
    this.end = this.start;
    this.startPosition = this.currentPosition;
};

PanelSlider.prototype.touchMove = function(e) {
    if (!this.isTouching) {
        return;
    }
    this.$carousel.style.transitionDuration = '0ms';
    this.end = e.touches ? e.touches[0].pageX : e.pageX;
    this.setPosition(this.startPosition + (this.end - this.start));
};

PanelSlider.prototype.touchEnd = function() {
    if (this.isTouching) {
        var change = this.start - this.end;

        this.isTouching = false;
        this.$carousel.style.transitionDuration = this.options.transitionDuration;

        if (Math.abs(change) > this.touchThreshold) {
            this.slideTo(this.startPosition + this.containerWidth * (change > 0 ? -1 : 1));
        } else {
            this.slideTo(this.startPosition);
        }
    }
};

PanelSlider.prototype.loadImage = function() {
    if (this.loaded) {
        return;
    }

    [].slice.call(this.$carousel.querySelectorAll('[data-src]')).forEach(function($img) {
        $img.src = $img.dataset.src;
    });

    this.loaded = true;
};

PanelSlider.prototype.handleClick = function(e) {
    preventClickIfMoved(e, this.start, this.end);

    if (e.target.matches('.ps-next, .ps-prev')) {
        this.slideTo(this.currentPosition + this.containerWidth * (e.target.matches('.ps-next') ? -1 : 1));
    }
};

PanelSlider.prototype.setPosition = function(position) {
    if (position <= 0 && position >= this.negativePositionLimit) {
        this.currentPosition = position;
        this.$carousel.style.left = position + 'px';
    }
};

PanelSlider.prototype.slideTo = function(position) {
    if (position <= 0 && position >= this.negativePositionLimit) {
        this.setPosition(position);
        if (this.isLargeScreen) {
            this.showArrows(position);
        }

        if (!this.isLargeScreen) {
            this.setActiveProgresIndicator(this.getPageIndexFromPosition(position));
        }
    }
};

PanelSlider.prototype.slideToPageByItemIndex = function(index) {
    this.loadImage();
    this.slideTo(-(Math.floor(index / this.itemsPerPage) * this.containerWidth));
};

PanelSlider.prototype.showArrows = function(position) {
    if (position === 0) {
        this.$prev.style.display = 'none';
        if (this.pageCount > 1) {
            this.$next.style.display = 'block';
        }
    } else if (position === this.negativePositionLimit) {
        this.$prev.style.display = 'block';
        this.$next.style.display = 'none';
    } else {
        this.$prev.style.display = 'block';
        this.$next.style.display = 'block';
    }
};

PanelSlider.prototype.destroy = function() {
    this.$$items.forEach(
        function($item) {
            $item.removeAttribute('style');
            $item.classList.remove('ps-item');
        }.bind(this)
    );

    this.$carousel.classList.remove('ps-content');
    this.$carousel.style.removeProperty('min-width');
    this.$carousel.style.removeProperty('transition-duration');
    this.$wrapper.parentElement.appendChild(this.$carousel);
    this.$wrapper.parentElement.removeChild(this.$wrapper);
};


function calcItemsPerPage(itemWidth, containerWidth) {
    const BUFFER = 10;
    let itemsPerPage = Math.floor(containerWidth / itemWidth);

    if (containerWidth - (itemWidth * itemsPerPage) <= BUFFER) {
        itemsPerPage--;
    }

    return itemsPerPage;
}

function extend() {
    var args = [].slice.call(arguments),
        destination = args[0];

    args.slice(1).forEach(function(obj) {
        Object.keys(obj).forEach(function(key) {
            destination[key] = obj[key];
        });
    });

    return destination;
}

function addProgessIndicator(instance) {
    var i = 0,
        l = instance.pageCount,
        $indicator;
    instance.$wrapper.classList.add('ps-show-progress-indicator');
    instance.$progress = document.createElement('div');
    instance.$progress.setAttribute('aria-hidden', 'true');
    instance.$progress.classList.add('ps-progress');

    for (; i < l; i++) {
        $indicator = document.createElement('div');
        $indicator.classList.add('ps-indicator');
        instance.$progress.appendChild($indicator);
    }

    instance.$wrapper.appendChild(instance.$progress);
}

function addNavigation(instance) {
    var $region = instance.$controls;

    $region.setAttribute('role', 'region');
    $region.setAttribute('aria-label', 'Slideshow Controls');

    instance.$wrapper.classList.add('ps-show-navigation');
    instance.$prev = document.createElement('button');
    instance.$next = document.createElement('button');
    instance.$prev.classList.add('ps-prev');
    instance.$next.classList.add('ps-next');
    instance.$prev.setAttribute('aria-label', 'Previous');
    instance.$next.setAttribute('aria-label', 'Next');

    $region.appendChild(instance.$prev);
    $region.appendChild(instance.$next);

    instance.$wrapper.appendChild($region);
}

function adjustItemToFitEvenlyWithInContainer(instance) {
    if (instance.containerWidth / instance.itemsPerPage > instance.itemWidth) {
        var addedMargin = (instance.containerWidth / instance.itemsPerPage - instance.itemWidth) / 2;

        instance.$$items.forEach(function($item) {
            $item.style.marginLeft = addedMargin + 'px';
            $item.style.marginRight = addedMargin + 'px';
        });
    }
}

function preventClickIfMoved(event, start, end) {
    var clickMovementThreshold = 5;
    if (start !== undefined && end !== undefined && Math.abs(start - end) > clickMovementThreshold) {
        event.preventDefault();
        event.stopPropagation();
    }
}

function lazyLoadImagesOnFirstInteraction($element, loadImages) {
    if(!window.IntersectionObserver){
        loadImages();
        return;
    }

    var  observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                observer.unobserve(entry.target);
                loadImages();
            }
        });
    }, {rootMargin: '320px', threshold: 0});

    observer.observe($element);
}

export default PanelSlider;
